import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

export const getThumbnailUrl = (thumbnail: string, src: string, type: string) =>
  `${thumbnail}${encodeURIComponent(`"${src}"`)}&type=${type}`;

interface IProps
  extends DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  thumbnail: string;
  src: string;
  type: string;
}

const ThumbnailImage = ({ thumbnail, src, type, ...props }: IProps) => (
  <img {...props} src={getThumbnailUrl(thumbnail, src, type)} />
);

export default ThumbnailImage;
